import { Product } from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import type { ApplicationContext } from '@/creditflowresearch/application/withApplicationPropsV2';

export const getProductsRegionsDefaults = (context: ApplicationContext): Record<string, string> => {
  const { productIds = [], regionIds = [] } = context.productsRegions || {};

  const products = productIds.map((id) => Product.getAbbreviation(id)).filter(Boolean).join(',');
  const regions = regionIds.map((id) => Region.getAbbreviation(id)).filter(Boolean).join(',');

  return {
    ...(products && { products }),
    ...(regions && { regions }),
  };
};
